import { useState } from 'react';
import { GalleryHorizontalEnd, Loader2, MessageCircle, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import type { QuoteSendFormat } from '@/utils/quoteText';

export interface QuoteSendFormatModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (format: QuoteSendFormat) => Promise<void>;
  busy: boolean;
}

export function QuoteSendFormatModal({ open, onOpenChange, onConfirm, busy }: QuoteSendFormatModalProps) {
  const [format, setFormat] = useState<QuoteSendFormat>('carousel');
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!busy) onOpenChange(next); }}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-lg" aria-describedby={undefined}
        onEscapeKeyDown={(event) => { if (busy) event.preventDefault(); }}
        onPointerDownOutside={(event) => { if (busy) event.preventDefault(); }}>
        <DialogHeader><DialogTitle>Enviar proposta</DialogTitle></DialogHeader>
        <RadioGroup value={format} disabled={busy} aria-label="Formato de envio"
          onValueChange={(value) => { if (value === 'carousel' || value === 'text') setFormat(value); }}>
          <Label htmlFor="quote-format-carousel" className="flex items-center gap-3 rounded-lg border border-border p-4 cursor-pointer">
            <RadioGroupItem id="quote-format-carousel" value="carousel" />
            <GalleryHorizontalEnd className="h-5 w-5 shrink-0 text-muted-foreground" />
            <span>Mensagem + Carrossel</span>
          </Label>
          <Label htmlFor="quote-format-text" className="flex items-center gap-3 rounded-lg border border-border p-4 cursor-pointer">
            <RadioGroupItem id="quote-format-text" value="text" />
            <MessageCircle className="h-5 w-5 shrink-0 text-muted-foreground" />
            <span>Apenas Mensagem</span>
          </Label>
        </RadioGroup>
        <DialogFooter className="flex-row justify-end gap-2 sm:space-x-0">
          <Button variant="outline" disabled={busy} onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button disabled={busy} onClick={() => void onConfirm(format)}>
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}
            {busy ? 'Enviando...' : 'Confirmar envio'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}